class Helpers {
  handleApiError(error, defaultMessage = "An error occurred") {
    let errorMessage = defaultMessage;

    if (error.request) {
      errorMessage = "Network error. Please check your connection.";
    }
    if (error.message) {
      errorMessage = error.message;
    }
    if (error.response.data?.data?.reason) {
      errorMessage = error.response.data.data.reason;
    }
    if (error.response.data?.message) {
      errorMessage = error.response.data.message;
    }
    if (error.response.data?.error) {
      errorMessage = error.response.data.error;
    }
    if (error.response.status === 409) {
      errorMessage = "User already exists with this email or phone number.";
    }
    if (error.response.status === 500) {
      errorMessage = "Server error. Please try again later.";
    }
    if (error.response.status === 401) {
      errorMessage = "Current password is incorrect.";
    }
    if (error.response.status === 403) {
      errorMessage = "You are not authorized to access this resource.";
    }
    if (error.response.status === 404) {
      errorMessage = "Resource not found.";
    }
    if (error.response.status === 405) {
      errorMessage = "Method not allowed.";
    }
    if (error.response.status === 406) {
      errorMessage = "Not acceptable.";
    }
    return {
      status: false,
      message: errorMessage,
      data: null,
    };
  }
  handleApiSuccess(data, message = "Action successful") {
    let successMessage = message;
    if (data?.data?.reason) {
      successMessage = data.data.reason;
    }
    return {
      status: true,
      message: successMessage,
      data: data,
    };
  }
}

const helpers = new Helpers();
export default helpers;
